import * as React from "react";

function SvgCrazyEgg(props, ref) {
  return (
    <svg
      viewBox="170 -5 61.807 94.361"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#8ABC00"
        d="M221.806 30.221C221.806 13.528 206.657 0 199.284 0c-7.375 0-22.526 13.528-22.526 30.222 0 8.065 2.358 15.386 6.196 20.805 1.301 2.729 3.33 5.613 5.43 8.59 2.415 3.43 4.879 6.949 6.279 10.326a4.98 4.98 0 00-2.821 2.812c1.21.273 2.535.504 3.944.662 3.793.418 7.166.23 9.1-.391-1.223.998-4.889 1.541-9.18 1.254a31.455 31.455 0 01-4.149-.547 4.975 4.975 0 00-.072.834v6.209c0 2.75 2.228 3.482 4.973 3.482h6.914c2.744 0 4.973-.734 4.973-3.482v-6.209c0-2.357-1.649-4.324-3.854-4.834.863-2.008 1.871-3.977 2.857-5.904l.977-1.918.703-1.406c.547-1.098 1.45-2.914 2.387-4.749h-.086c6.292-5.359 10.477-14.787 10.477-25.535zm-14.023 29.665l-.699 1.402-.973 1.906c-1.064 2.082-2.149 4.211-3.068 6.4h-3.068V60.44h-1.385v9.154h-2.137c-.146 0-.279.031-.422.043-1.442-3.59-4.008-7.254-6.52-10.82-.656-.933-1.31-1.856-1.933-2.769 3.41 2.787 7.416 4.39 11.701 4.39 3.47 0 6.756-1.055 9.689-2.935-.362.736-.756 1.524-1.185 2.383zm-.291-2.357s7.037-7.672 9.15-18.554c-2.636 3.21-7.214 5.341-12.432 5.341-8.171 0-14.798-5.215-14.798-11.646 0-6.436 6.627-11.65 14.798-11.65 5.077 0 9.555 2.015 12.221 5.082-4.287-17.776-23.612-22.228-23.612-22.228s1.205-1.545 3.823-2.294c2.224-.637 3.312-.478 4.726-.059 1.604.476 18.664 9.975 18.664 28.132-.001 18.158-12.54 27.876-12.54 27.876z"
      />
      <path
        fill="#8ABC00"
        d="M209.555 29.526c-1.318 0-2.492-.688-4.18-.688-3.005 0-4.433 1.794-4.433 3.61 0 1.744 1.57 3.562 4.433 3.562 1.321 0 3.299-.733 3.924-.733 1.247 0 2.271.71 2.271 1.544 0 1.817-4.545 2.433-6.447 2.433-5.687 0-9.456-3.117-9.456-6.805 0-3.586 3.885-6.85 9.456-6.85 2.085 0 6.447.513 6.447 2.235.001.737-.765 1.692-2.015 1.692z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgCrazyEgg);
